import React, { useState, useEffect } from "react";
import { Header, Button } from "../components";
import { AgentName, intentTypeData, sentimentTypeData, intentTypeDataOnlyFour, fileNamePatternIntent, fileNamePatternSentiment  } from "../data/dummy";
import { useStateContext } from "../contexts/ContextProvider";
import { useLocation, useNavigate } from "react-router-dom";
import AgentCommentMaster from "../components/AgentCommentMaster";
import AgentComment from "../components/AgentComment";

import Wordnetwork from "../components/Wordnetwork";
import axios from 'axios';
import Swal from 'sweetalert2';

const VisualizeWordnetwork = () => {

  //데몽이
  const [isRequestSent_network, setIsRequestSent_network] = useState(false);
  const [lambdaResult_network, setLambdaResult_network] = React.useState("버튼을 누르면 분석을 도와드려요!");

  const { currentColor } = useStateContext();
  const [userId, setUserId] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  const [keywordColors, setKeywordColors] = useState({});
  const [graphData, setGraphData] = useState({ nodes: [], links: [] });

  // location.state의 데이터를 반영
  useEffect(() => {
    if (location.state) {
      setKeywordColors({ ...location.state.keywordColors });
      setGraphData({ ...location.state.graphData });
    }

    const storedUserID = localStorage.getItem('userId');
    setUserId(storedUserID || '');
    console.log(`storedUserID: ${storedUserID}`);

  }, [location.state]);

  const initializeGraphData = (data) => {
    setGraphData(data);
  };

  const handleLambdaRequest = async () => {
    if (isRequestSent_network) return;
    // 요청 상태 업데이트
    setIsRequestSent_network(true);

    const vis_network = "수수료-이체 53건, 계좌-불편 43건, 사용-송금 32건, 접속-인증 23건, 포인트-송금 22건, 불편-사용 21건, 알림-사용 20건, 카드-금융 19건, 송금-결제 10건, 알림-계좌 9건";
    try {
      let requestData;

      requestData = {
        name: "llm_vis_1",
        vis_network: vis_network,
      };
      const response = await axios.post(
        "https://farqijyj9a.execute-api.ap-northeast-2.amazonaws.com/241113/agent",
        requestData
      );

      // 요청 데이터 출력
      console.log("요청 데이터:", requestData);

      // Lambda 응답 디코딩 및 처리
      const responseBody = JSON.parse(response.data.body); // `body`를 JSON으로 파싱
      console.log("Lambda 응답:", responseBody);

      // Lambda 결과값 반영
      setLambdaResult_network(responseBody.answer || "결과를 불러왔습니다.");

    } catch (error) {
      console.error("Lambda 호출 중 오류 발생:", error);
      setLambdaResult_network("오류가 발생했습니다. 다시 시도해주세요.");
    } finally {
      // 요청 상태 초기화 (성공/실패 관계 없이 재시도 불가)
      setIsRequestSent_network(true);
    }
  };

  const handleNetwork = (intentName, sentiment, intentIndex, sentimentIndex) => {

    return (
      <div
      className="flex-1"
      style={{
        width: "100%",
        maxWidth: "100%",
        overflowX: "hidden", // 가로 스크롤 방지
        boxSizing: "border-box",
      }}
    >
        <div className="flex gap-5">
          <p className="text-s font-semibold">{sentiment} 리뷰</p>
          {/* <Button
            color="white"
            bgColor={currentColor}
            text="차트 편집하기"
            borderRadius="10px"
            onClick={() => navigate("/vis/wordnetwork-detail",
              { state: { graphData, keywordColors, intentName, sentiment } })}
          /> */}
        </div>
        <br /><br /><br />
        <Wordnetwork
          id={`nework-${intentIndex}-${sentimentIndex}`}
          keywordColors={keywordColors}
          initializeGraphData={initializeGraphData}
          graphData={graphData}
          intentIndex={intentIndex}
          sentimentIndex={sentimentIndex}
        />
      </div>
    )
  }

  return (
    <div className="m-2 md:m-10 mt-0 p-2 md:p-10 bg-white rounded-3xl">
      <Header category="데이터 시각화" title="키워드 연결망 시각화" />
      <button
        onClick={async () => {
          console.log("Button clicked!"); // 클릭 시 콘솔 출력

          const swalInstance = Swal.fire({
            title: '인사이트 분석 시작',
            html: '새로고침하지 마시고 잠시만 기다려주세요.<br>최대 1분까지 소요될 수 있어요.',
            icon: 'info',
            timer: 60000, // 1분 타이머 설정
            allowOutsideClick: false, // 팝업 밖 클릭 비활성화
            allowEscapeKey: false,    // ESC 키 비활성화
            allowEnterKey: false,     // 엔터 키 비활성화
            timerProgressBar: true,   // 타이머 진행 바 표시
            didOpen: () => {
              Swal.showLoading();     // 팝업 로딩 애니메이션 표시
            },
          });

          try {
            const response = await handleLambdaRequest(); // Lambda 요청 실행
            console.log('Response received:', response);

            // 요청 성공 시 팝업 닫기
            Swal.close();
            Swal.fire({
              title: '분석 완료',
              html: '데몽이의 분석 가이드를 확인해 보세요 :)',
              icon: 'success',
              confirmButtonText: '확인',
              confirmButtonColor: currentColor,
            });
          } catch (error) {
            console.error('Error during request:', error);

            // 요청 실패 시 에러 팝업 표시
            Swal.close();
            Swal.fire({
              title: '분석 실패',
              html: '요청을 처리하는 중 오류가 발생했습니다.<br>다시 시도해주세요.',
              icon: 'error',
              confirmButtonText: '확인',
              confirmButtonColor: currentColor,
            });
          }
        }}
        style={{
          backgroundColor: currentColor, // 배경색
          color: 'white',                // 텍스트 색상
          borderRadius: '10px',          // 모서리 둥글게
          padding: '12px 24px',          // 버튼 패딩
          fontSize: '16px',              // 폰트 크기
          cursor: 'pointer',             // 마우스 커서
          border: 'none',                // 테두리 제거
          transition: 'background-color 0.3s', // 배경색 변화에 트랜지션 추가
        }}
        className="hover:bg-gray-700 hover:drop-shadow-xl" // 호버 시 효과 추가
      >인사이트 분석시작</button>
      <AgentCommentMaster
        title={"데몽이의 조언 듣기"}
        comment={lambdaResult_network}
      />
      <div className="m-2 md:m-5 mt-0 p-2 md:p-5 bg-white rounded-3xl">
        {intentTypeDataOnlyFour.map((intentName, intentIndex) => (
          <div style={{ maxWidth: '100%', overflowX: 'hidden' }}>
            <p className="text-xl font-semibold">{intentName} 리뷰</p><br />
            <div className="flex gap-5"
            style={{
              maxWidth: "100%", // 부모 컨테이너의 최대 너비를 100%로 제한
              overflowX: "hidden", // 가로 스크롤 방지
              margin: "0 auto", // 중앙 정렬
            }}
            >
              {
                sentimentTypeData.map((sentiment, sentimentIndex) => (
                  handleNetwork(intentName, sentiment, intentIndex, sentimentIndex)
                ))
              }
            </div>
            <br /><br />
            <hr className="my-8 border-gray-300" />
          </div>
        ))
        }

      </div>
    </div>
  );
};

export default VisualizeWordnetwork;